import React, { useState } from "react";
import { DangerButton, SuccessButton } from "../ui/buttons/Button";
import { Input, Textarea } from "../ui/inputs/Input";
import Modal from "react-bootstrap/Modal";
import { Mensaje, MensajeSiNo } from "../components/mensajes2";
import axios from "axios";
import { Dimmer } from "../components/spinner";

const CatalogoFabricantes = (props) => {
  const op = require("../modulos/datos");
  const token = localStorage.getItem("jwtToken");
  const [activate, setActivate] = useState(false);
  const [body, setBody] = useState({
    idfabricante: "",
    descripcion: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const onChangeValidar = () => {
    if (body["descripcion"].trim() === "") {
      setMensaje({
        mostrar: true,
        titulo: "Notificación.",
        texto: "¡Debe Introducir la Descripción!",
        icono: "error",
      });
      return;
    }
    let msg = "";
    if (props.operacion === 1) {
      msg = "Esta Seguro de Registrar estos Datos.";
    } else if (props.operacion === 2) {
      msg = "Esta Seguro de Modificar estos Datos.";
    } else if (props.operacion === 3) {
      msg = "Esta Seguro de Eliminar estos Datos.";
    }
    setMensajesino({
      mostrar: true,
      titulo: "Confirmación.",
      texto: msg,
      icono: "confirmacion",
    });
  };
  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarRegistro();
  };
  const procesarRegistro = () => {
    try {
      setActivate(true);
      const ope = props.operacion;
      const json = {
        operacion: ope,
        fabricante: [
          {
            ...body,
            idfabricante: body.idfabricante === "" ? null : body.idfabricante,
          },
        ],
      };
      const endpoint = `${op.conexion}/api/comprasAlmacen/actfabricante`;
      axios
        .post(endpoint, json, {
          headers: {
            "x-access-token": `${token}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (ope === 1) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto: "Registro Creado Correctamente",
                icono: "exito",
              });
            } else if (ope === 2) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto: "Registro Modificado Correctamente",
                icono: "exito",
              });
            } else if (ope === 3) {
              setMensaje({
                mostrar: true,
                titulo: "Exito.",
                texto: "Registro Eliminado Correctamente",
                icono: "exito",
              });
            }
          }
        })
        .catch(() => {
          setMensaje({
            mostrar: true,
            titulo: "Error",
            texto: "Ocurrió un error inesperado",
            icono: "error",
          });
        })
        .finally(() => {
          setActivate(false);
        });
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "Error",
        texto: "Ocurrió un error inesperado",
        icono: "error",
      });
    }
  };
  const blanquear = () => {
    props.onHideCancelar();
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setBody({
      idfabricante: "",
      descripcion: "",
    });
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideRenderizar();
  };
  return (
    <Modal
      {...props}
      size="xs"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        if (props && props.fabricante) {
          setBody(props.fabricante);
        }
      }}
    >
      <Modal.Header className="azulGradiant">
        <h3 className="fw-bold m-0">
          {props.operacion === 1
            ? "Agregar Fabricante."
            : props.operacion === 2
              ? "Editar Fabricante."
              : props.operacion === 3
                ? "Eliminar Fabricante."
                : "Consultar Fabricante."}
        </h3>
        <a
          className="fw-bold fs-6 text-light"
          type="button"
          onClick={blanquear}
        >
          Salir<i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body style={{ backgroundColor: "#fff", color: "" }}>
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-6 m-0 p-0 mb-2">
          <Input
            label="Código:"
            disabled={true}
            name="idunidadmedida"
            id="inputCodigo"
            defaultValue={body["idfabricante"]}
          />
        </div>
        <div className="col-12 m-0 p-0">
          <Textarea
            disabled={
              props.operacion === 4 || props.operacion === 3 ? true : false
            }
            label="Descripción:"
            style={{ height: 70 }}
            name="descripcion"
            id="inputDescripcion"
            defaultValue={body["descripcion"]}
            onChange={(e) => {
              const value = e.target.value;
              setBody({
                ...body,
                descripcion: `${value}`.toUpperCase().trim(),
              });
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          disabled={props.operacion === 4 ? true : false}
          onClick={() => onChangeValidar()}
        >
          Aceptar
        </SuccessButton>
        <DangerButton onClick={blanquear}>Cancelar</DangerButton>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? blanquear()
            : setMensaje({
                mostrar: false,
                titulo: "",
                texto: "",
                icono: "",
              });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={() => handleCloseSi()}
      />
    </Modal>
  );
};

export default CatalogoFabricantes;
